import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SlidesShowForm from './SlidesShowForm';
import { header } from '../../components/header.encry';
import StoresHelper from '../../components/storesHelper';
import { toast } from 'react-toastify';

function SlidesShowTable() {
    const [slideshows, setSlideshows] = useState([]);
    const [selectedSlideShow, setSelectedSlideShow] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [stores, setStores] = useState([]);
    const fetchSlideshows = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_PEGASUS_API_URL}/slides`, header());
            if (response.data.result) {
                setSlideshows(response.data.data);
                console.log(response.data);
            }

        } catch (error) {
            console.error('Erreur lors de la récupération des slideshows', error);
        }
    };

    useEffect(() => {
        fetchSlideshows();
        (async function () {
            setStores(await StoresHelper());
        })();
    }, []);

    const handleEdit = (slide) => {
        setSelectedSlideShow(slide);

    };

    const handleDelete = async (id) => {
        if (window.confirm("Voulez-vous vraiment supprimer ce slide ?")) {
            try {
                const res = await axios.delete(`${process.env?.REACT_APP_PEGASUS_API_URL}/slide/${id}`, header());
                if (res.data.result)
                    toast.success("Slide Supprimé avec succès");
                else
                    toast.error("Une erreur est survenu lors la suppression du slide");
                fetchSlideshows();
            } catch (error) {
                toast.error('Erreur lors de la suppression', error);
            }
        }
    };
    const updateSlideAvailability = async ( slideId, storeId, availability ) => {
      
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_PEGASUS_API_URL}/slide/${slideId}/store/${storeId}/availability`,
                { availability }, // body
                header()
            );

            if (response.data.result) {
                toast.success('Disponibilité mise à jour avec succès.');
                fetchSlideshows();
            } else {
                toast.error('Erreur lors de la mise à jour :', response.data.response);
                throw new Error(response.data.response);
            }
        } catch (error) {
            toast.error('Erreur réseau ou serveur :', error.message);
            throw error;
        }
    };

    const handleAdd = () => {
        setSelectedSlideShow(null);

    };

    return (
        <div>
            <div className='row'>
                <div className='col-8'> <h2>Slideshows </h2></div>
                <div className='col-4 text-end'><span className='btn btn-dark' onClick={fetchSlideshows}>Refresh <i class="fa-solid fa-rotate-right"></i></span></div>
            </div>
           
            <button className="btn btn-success mb-3" onClick={handleAdd} data-bs-toggle="modal" data-bs-target="#slideShowForm">Ajouter un Slide</button>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Description</th>
                        <th>Image URL</th>
                        <th>Magasins</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {slideshows?.map((slide, index) => (
                        <tr key={index}>
                            <td>{slide.description}</td>
                            <td><img src={`${process.env.REACT_APP_DATA_PIC_PATH}/${slide.url}`} width={120}  /></td>
                            <td>
                                {slide.stores?.map((s, i) => (
                                    <div key={i}>
                                        <span class="badge text-bg-warning">{s.position} - <input type='checkbox' onClick={()=>updateSlideAvailability(slide._id,s.storeid,!s.activated)} checked={s.activated} /> {stores.find(store => store.id == s.storeid)?.label} </span>
                                    </div>
                                ))}
                            </td>
                            <td>
                                <button className="btn btn-primary btn-sm me-2" onClick={() => handleEdit(slide)} data-bs-toggle="modal" data-bs-target="#slideShowForm">Modifier</button>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(slide._id)}>Supprimer</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


            <SlidesShowForm
                currentSlideShow={selectedSlideShow}
                onSave={fetchSlideshows}

            />

        </div>
    );
}

export default SlidesShowTable;
